import { render, staticRenderFns } from "./ReferralSteps.vue?vue&type=template&id=74a91109&scoped=true&"
import script from "./ReferralSteps.vue?vue&type=script&lang=js&"
export * from "./ReferralSteps.vue?vue&type=script&lang=js&"
import style0 from "./ReferralSteps.vue?vue&type=style&index=0&id=74a91109&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a91109",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default})
